import { StateRegistrationCitizenship } from 'mutation/constants/state-registration-citizenship';
import { CitizenshipFormVM } from 'mutation/view-models/registration-citizenship';
import { DatiAggiuntiviSide, ModelEventoDTO } from 'shell/models/act-category-list';
import { transformerNewCitizenshipOpenLegis } from './transformer-new-citizenship-open-legis';
import { transformerNewCitizenshipDPR } from './transformer-new-citizenship-DPR';
import { transformerNewCitizenshipDP } from './transformer-new-citizenship-DP';
import { ItemVM } from 'shell/view-models/item';
import { MotArtCitizenship } from 'shell/models/mutation/mot-art-citizenship';
import { transformerNewChoiceItalian } from './transformer-new-choice-italian';

export const transformerNewCitizenship = (
  modelEventoDTO?: ModelEventoDTO,
  datiAggiuntiviSide?: DatiAggiuntiviSide,
  subEvento?: string,
  motivoVariazioneCittadinanza?: ItemVM<MotArtCitizenship>
): CitizenshipFormVM | undefined => {
  switch (subEvento) {
    case StateRegistrationCitizenship.OpenLegis:
      return transformerNewCitizenshipOpenLegis(modelEventoDTO, motivoVariazioneCittadinanza);
    case StateRegistrationCitizenship.ToDPR:
      return transformerNewCitizenshipDPR(
        modelEventoDTO,
        datiAggiuntiviSide,
        subEvento,
        motivoVariazioneCittadinanza
      );
    case StateRegistrationCitizenship.ItalianCitizenshipDP:
      return transformerNewCitizenshipDP(
        modelEventoDTO,
        datiAggiuntiviSide,
        subEvento,
        motivoVariazioneCittadinanza
      );
    case StateRegistrationCitizenship.ChoiceItalian:
      return transformerNewChoiceItalian(
        modelEventoDTO,
        datiAggiuntiviSide,
        subEvento,
        motivoVariazioneCittadinanza
      );
    default:
      return;
  }
};
